<div class="main-page-content container">
  <div class="main-page-content-block">



    <div class="row">
      <div class="col-12  ">
        <p-table #dt1
                 dataKey="ID"
                 [value]="list"
                 [responsive]="true"
                 [paginator]="false"
                 [rows]="100"
                 [loading]="loadingList"
                 [showCurrentPageReport]="true"
                 currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                 [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
                 [lazy]="false"
                 styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped  ">

          <ng-template pTemplate="caption">
            <div class="d-flex justify-content-end ">

              <div class="p-2 flex-fill"><h1 class="content-heading-font">Backups</h1></div>
              <div class="ml-auto">

                <button class="btn btn-primary " (click)="loadTable()" title="Refresh">
                  <i class="pi pi-refresh" [ngClass]="{'pi-spin': loadingList}"></i>
                </button>

              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th class="text-center" style="width:70px;"></th>
              <th class="text-start">
                Backup Name
              </th>
              <th class="text-start">
                Backup Type
              </th>
              <th class="text-center">
                Backup Date
              </th>
              <th class="text-start">
                File Name
              </th>
              <th class="text-start">
                File Location
              </th>
              <th class="text-end">
                File Size
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-item>
            <tr>
              <th class="text-center">
                <div class="gap-2 d-block text-">
                  <a class="btn btn-sm btn-secondary me-1  " (click)="download(item)" title="Download Backup">
                    <i class="pi pi-download"></i>
                  </a>
                </div>
              </th>
              <td class="text-start">
                {{ item.Name }}
              </td>
              <td class="text-start">
                {{ item.BackupType }}
              </td>
              <td class="text-center">
                <span title="{{ formatMountainTime(item.FileDate) }}">{{ getTimeFromNow(item.FileDate) }}</span>
              </td>
              <td class="text-start">
                {{ item.FileName }}
              </td>
              <td class="text-start">
                {{ item.BackupLocation }}
              </td>
              <td class="text-end">
                {{ formatSize(item.FileSize) }}
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="10">No items found.</td>
            </tr>
          </ng-template>



        </p-table>



      </div>
    </div>

  </div>
</div>



<p-dialog header="Request database backup of {{currentBackup?.Name}}" [modal]="true" [visible]="currentBackup!=null" styleClass="p-dialog-no-scroll" closable="false" resizable="false">


  <p class="pl-1 text-lg alert alert-danger " style="background-color:red; color:white; text-align: justify">
    Downloading <b>Protected Health Information (PHI)</b> to any unapproved device or storage location constitutes a severe breach of confidentiality and may result in significant legal, regulatory, and disciplinary consequences. <br />
    PHI must be accessed and retained only within authorized, secure systems to ensure full compliance and protect patients from irreversible privacy violations.
  </p>
  <p class="pl-1 text-lg">
    Please setup a password with at least 10 characters for the database backup file.
  </p>
  <div class="row">
    <div class="col mb-3">
      <label for="dbPassword">File Password</label>
      <input class="form-control" maxlength="64" type="text" name="dbPassword" autocomplete="new-password" [(ngModel)]="dbPassword" required="required" />
    </div>
  </div>
  <div class="row">
    <div class="col mb-3">
      <label for="dbPasswordConfirm">Confirm file password</label>
      <input class="form-control" maxlength="64" type="text" name="dbPasswordConfirm" autocomplete="new-password" [(ngModel)]="dbPasswordConfirm" required="required" />
    </div>
  </div>

  <div class="row">
    <div class="col text-center">
      <button class="btn btn-lg btn-primary" type="submit" id="btnRequestBackup" [class.button-loading]="loading" (click)="DoRequestBackup()">Confirm</button>
      <button class="btn btn-lg btn-secondary ms-2" type="button" id="btnRequestBackupCancel" [class.button-loading]="loading" (click)="currentBackup=null">Cancel</button>
    </div>
  </div>
</p-dialog>

